import type {
  ClientCreate,
  ClientUpdate,
} from "@/types/clients/api-types/client-types";
import type { ClientFormValues } from "@/default-form-values/clients/default-client-form-values";
import { toIsoDate } from "@/lib/utils";

export const emptyToNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed === "" ? null : trimmed;
};

export const toClientRequest = (
  value: ClientFormValues
): ClientCreate & ClientUpdate => ({
  first_name: value.first_name.trim(),
  last_name: value.last_name.trim(),
  preferred_name: emptyToNull(value.preferred_name),
  pronouns: emptyToNull(value.pronouns),
  phone: emptyToNull(value.phone),
  email: value.email.trim(),
  address: emptyToNull(value.address),
  recommended_by: emptyToNull(value.recommended_by),
  birthday: value.birthday ? toIsoDate(value.birthday) : null,
  notes: emptyToNull(value.notes),
});
